import { render, staticRenderFns } from "./GenericControlRiskScenario.vue?vue&type=template&id=eed4d334&scoped=true&"
import script from "./GenericControlRiskScenario.vue?vue&type=script&lang=js&"
export * from "./GenericControlRiskScenario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed4d334",
  null
  
)

export default component.exports